import { useEffect } from 'react';
import { Link } from 'react-router';
import clsx from 'clsx';

import { useLeaderboardStore } from '@/entities/leaderboard';
import { useSessionStore } from '@/entities/session';
import { ROUTES } from '@/shared/config';
import { formatScore } from '@/shared/lib';
import { RADIUS, Skeleton, Squircle } from '@/shared/ui';

import styles from './TopPlayers.module.scss';

/** «Топ 10 игроков» на главном экране (узел 438:48323). */
export function TopPlayers() {
  const displayName = useSessionStore((state) => state.user?.displayName ?? state.user?.firstName);
  const weekly = useLeaderboardStore((state) => state.weekly);
  const isLoading = useLeaderboardStore((state) => state.weeklyIsLoading);
  const loadWeekly = useLeaderboardStore((state) => state.loadWeekly);

  useEffect(() => {
    void loadWeekly();
  }, [loadWeekly]);

  const top10 = weekly?.entries.slice(0, 10) ?? [];

  return (
    <Squircle cornerRadius={RADIUS.xl} className={styles.root}>
      <h2 className={styles.title}>Топ 10 игроков</h2>

      {isLoading && !weekly ? <Skeleton count={10} height={32} /> : null}

      {weekly ? (
        <div className={styles.table}>
          <div className={styles.headRow}>
            <span className={styles.place}>Место</span>
            <span className={styles.username}>Ник</span>
            <span className={styles.score}>Счёт</span>
          </div>

          {top10.map((entry) => {
            const isMe = entry.rank === weekly.me.rank;
            return (
              <div className={clsx(styles.row, isMe && styles.rowYou)} key={entry.userId}>
                <span className={styles.place}>
                  <img
                    className={styles.fireIcon}
                    src={isMe ? '/images/icons/fire-pink.svg' : '/images/header/fire.svg'}
                    alt=""
                    aria-hidden
                  />
                  {entry.rank}
                </span>
                <span className={styles.username}>{entry.displayName ?? '@игрок'}</span>
                <span className={styles.score}>{formatScore(entry.points)}</span>
              </div>
            );
          })}

          {/* Отдельная плашка — только когда игрок НЕ входит в топ-10:
              иначе он дублировался бы своей же строкой из списка выше
              (была именно эта ошибка). Внутри топ-10 своё место игрок
              видит подсветкой строки, см. .rowYou. */}
          {weekly.me.rank !== null && weekly.me.rank > 10 ? (
            <div className={clsx(styles.row, styles.youRow)} data-testid="top-players-you">
              <span className={styles.place}>{weekly.me.rank}</span>
              <span className={styles.username}>@{displayName ?? 'игрок'}</span>
              <span className={styles.score}>{formatScore(weekly.me.points)}</span>
            </div>
          ) : null}
        </div>
      ) : null}

      <Squircle asChild cornerRadius={RADIUS.xl}>
        <Link to={ROUTES.rating} className={styles.cta} data-testid="top-players-cta">
          Весь рейтинг
        </Link>
      </Squircle>
    </Squircle>
  );
}
